import { Text } from 'blaze-ui/Text/Text'
import { Button } from 'blaze-ui/Button'
import { Pause, Play3, Trash2 } from 'blaze-ui/icons/20'
import { BrandKitAvatar } from 'types'
import { VerificationPill } from './VerificationPill'
import Styles from './AvatarCard.module.scss'

interface Props {
  avatar: BrandKitAvatar
  isPreviewPlaying: boolean
  showVerification?: boolean
  onEdit?: (avatar: BrandKitAvatar) => void
  onDelete: (avatar: BrandKitAvatar) => void
  onTogglePreview: () => void
}

export const AvatarCard = ({
  avatar,
  isPreviewPlaying,
  showVerification = true,
  onEdit,
  onDelete,
  onTogglePreview,
}: Props) => {
  return (
    <div className={Styles.card} data-testid={`avatar-card-${avatar.id}`}>
      <div className={Styles.poster}>
        {avatar.photo_url ? <img src={avatar.photo_url} alt={avatar.name} /> : <div className={Styles.placeholder} />}
        <div className={Styles.posterFade} aria-hidden />
        {showVerification && (
          <div className={Styles.pillCorner}>
            <VerificationPill avatar={avatar} />
          </div>
        )}
        <div className={Styles.removeSlot}>
          <Button
            variant="secondary"
            size="md"
            frontIcon={Trash2}
            onPress={() => onDelete(avatar)}
            aria-label={`Remove ${avatar.name}`}
          >
            Remove
          </Button>
        </div>
        {avatar.voice?.sample_audio_url && (
          <button
            type="button"
            className={Styles.playButton}
            aria-label={`Preview ${avatar.name} voice`}
            onClick={onTogglePreview}
          >
            {isPreviewPlaying ? <Pause /> : <Play3 fill="currentColor" />}
          </button>
        )}
        {onEdit && (
          <div className={Styles.customizeSlot}>
            <Button
              variant="secondary"
              size="md"
              onPress={() => onEdit(avatar)}
              aria-label={`Customize ${avatar.name}`}
            >
              Customize
            </Button>
          </div>
        )}
      </div>
      <div className={Styles.info}>
        <Text fontWeight="500">{avatar.name}</Text>
        {avatar.persona_note && (
          <Text variant="secondary" lineClamp={1}>
            {avatar.persona_note}
          </Text>
        )}
      </div>
    </div>
  )
}
